import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ExtendedFileReference } from "@app/chat-new/user-message/user-message.component";
import { FilesService } from "@services/files/files.service";
import { Observable, Subject, takeUntil } from "rxjs";
import { ChipTypeConstant } from "@shared/constants/chip/chip-type";

@Component({
  selector: 'app-image-file-references-wrapper',
  templateUrl: './image-file-references-wrapper.component.html',
  styleUrls: ['./image-file-references-wrapper.component.css']
})
export class ImageFileReferencesWrapperComponent implements OnInit, OnDestroy {
  private readonly MAX_VISIBLE_FILES = 3;
  private readonly MAX_VISIBLE_FILES_PLUS = 5;

  @Input() fileReferences$!: Observable<ExtendedFileReference[]>;
  @Output() expanded = new EventEmitter<void>();

  validReferences: ExtendedFileReference[] = [];
  isCollapsed: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private filesService: FilesService
  ) {
  };

  ngOnInit(): void {
    this.fileReferences$
      .pipe(takeUntil(this.destroy$))
      .subscribe((refs) => {
        this.validReferences = refs.slice(0, this.MAX_VISIBLE_FILES_PLUS);
        this.isCollapsed = this.shouldHideExtraFiles;
      });
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get shouldHideExtraFiles(): boolean {
    return this.validReferences.length > this.MAX_VISIBLE_FILES;
  };

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.expanded.emit();
  };

  get hiddenReferencesCount(): number {
    return this.validReferences.length - this.MAX_VISIBLE_FILES + 1;
  };

  get firstRowFileReferences(): ExtendedFileReference[] {
    if (this.isCollapsed) {
      return this.validReferences.slice(0, this.MAX_VISIBLE_FILES - 1);
    }

    return this.validReferences.slice(0, this.MAX_VISIBLE_FILES);
  };

  get secondRowFileReferences(): ExtendedFileReference[] {
    return this.validReferences.slice(this.MAX_VISIBLE_FILES, this.MAX_VISIBLE_FILES_PLUS);
  };

  get rowDistributionClass(): string {
    const referencesCount = this.validReferences.length;

    if (referencesCount === 1) {
      return 'single';
    }

    return 'multiple';
  };

  openImageInNewTab(id: string): void {
    this.filesService.openFileInNewTab(id);
  };

  protected readonly ChipTypeConstant = ChipTypeConstant;
};
